import axios from "axios";
import {
  CONTACT_ACTIVITY_DATA_FAIL,
  CONTACT_ACTIVITY_DATA_REQUEST,
  CONTACT_ACTIVITY_DATA_SUCCESS,
} from "../constants/contactConstants";
import api from "../core/api";
let Api = process.env.REACT_APP_SEARCH_API_URL2;
export const getContactActivity =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CONTACT_ACTIVITY_DATA_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + userInfo,
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await api.post(
          `/activities/getDetailsForGuest`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: CONTACT_ACTIVITY_DATA_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: CONTACT_ACTIVITY_DATA_SUCCESS,
            payload: dt[0].Activity_Description,
          });
        }
      } else {
        dispatch({
          type: CONTACT_ACTIVITY_DATA_FAIL,
          payload: "User Not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: CONTACT_ACTIVITY_DATA_FAIL,
        payload: message,
      });
    }
  };

export const getContactCrmActivity =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CONTACT_ACTIVITY_DATA_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + userInfo,
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await axios.post(
          `${Api}/activities/getDetailsForGuest/crmuser`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: CONTACT_ACTIVITY_DATA_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: CONTACT_ACTIVITY_DATA_SUCCESS,
            payload: dt[0].Activity_Description,
          });
        }
      } else {
        dispatch({
          type: CONTACT_ACTIVITY_DATA_FAIL,
          payload: "User Not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: CONTACT_ACTIVITY_DATA_FAIL,
        payload: message,
      });
    }
  };
